import React from 'react';

export type NotificationType = 'email' | 'materialAdd' | 'materialUpdate';

export interface Notification {
  text: string | undefined;
  id: number;
  type: NotificationType;
  value: string;
  stateId?: number;
  materialId?: number;
  material?: {
    id: number;
    name: string;
  };
  createdAt: string;
  unread?: boolean;
}

export const getNotificationText = (notification: Notification): string => {
  switch (notification.type) {
    case 'email':
      return `Зарегистрировался новый пользователь: ${notification.text}`;
    case 'materialAdd':
      return `${notification.text || ''}`;
    case 'materialUpdate':
      return `${notification.text || ''}`;
    default:
      return 'Новое уведомление';
  }
};

export const getNotificationUrl = (notification: Notification): string => {
  switch (notification.type) {
    case 'email':
      return `/admin/users?search=${encodeURIComponent(notification.text || '')}`;
    case 'materialAdd':
    case 'materialUpdate':
      return notification.materialId ? `/learning/material/${notification.materialId}` : '/admin/materials';
    default:
      return '/';
  }
};
